import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Shield, Eye, Lock, FileText } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="section-padding">
        <div className="container-custom max-w-4xl">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-6">
              <Shield className="w-4 h-4 mr-2" />
              Política de Privacidad
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Protección de tus
              <span className="text-gradient"> Datos Personales</span>
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              En Atomic Corporation, valoramos tu privacidad y nos comprometemos a proteger 
              tu información personal con los más altos estándares de seguridad.
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
            <section>
              <div className="flex items-center mb-4">
                <Eye className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">1. Información Recopilada</h2>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                Recopilamos información personal que usted nos proporciona voluntariamente al contactarnos 
                a través de nuestro sitio web, formulario de contacto o newsletter.
              </p>
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="font-semibold text-gray-900 mb-3">Tipos de información que recopilamos:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Nombre completo y datos de contacto</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Información de la empresa (si aplica)</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Detalles de servicios requeridos</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Información de navegación y uso del sitio</span>
                  </li>
                </ul>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <FileText className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">2. Uso de la Información</h2>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                Utilizamos su información para proporcionar los mejores servicios industriales 
                y mantenerlo informado sobre nuestras soluciones.
              </p>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-primary-50 rounded-lg p-4">
                  <h3 className="font-semibold text-primary-900 mb-2">Comunicación</h3>
                  <p className="text-primary-700 text-sm">Responder a sus consultas y enviar información relevante</p>
                </div>
                <div className="bg-accent-50 rounded-lg p-4">
                  <h3 className="font-semibold text-accent-900 mb-2">Mejora</h3>
                  <p className="text-accent-700 text-sm">Mejorar nuestros productos y servicios continuamente</p>
                </div>
                <div className="bg-secondary-50 rounded-lg p-4">
                  <h3 className="font-semibold text-secondary-900 mb-2">Marketing</h3>
                  <p className="text-secondary-700 text-sm">Enviar información sobre ofertas especiales (con consentimiento)</p>
                </div>
                <div className="bg-green-50 rounded-lg p-4">
                  <h3 className="font-semibold text-green-900 mb-2">Legal</h3>
                  <p className="text-green-700 text-sm">Cumplir con obligaciones legales y regulatorias</p>
                </div>
              </div>
            </section>

            <section>
              <div className="flex items-center mb-4">
                <Lock className="w-6 h-6 text-primary-600 mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">3. Protección de Datos</h2>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">
                Nos comprometemos a proteger su información personal con medidas de seguridad 
                técnicas y organizativas apropiadas.
              </p>
              <div className="bg-gradient-to-r from-primary-50 to-accent-50 rounded-lg p-6">
                <h3 className="font-semibold text-gray-900 mb-3">Nuestras medidas de seguridad incluyen:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Encriptación de datos en transmisión y almacenamiento</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Acceso restringido a personal autorizado</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">Actualizaciones regulares de sistemas de seguridad</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-gray-700">No compartimos datos con terceros sin consentimiento</span>
                  </li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Cookies</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Nuestro sitio web utiliza cookies para mejorar su experiencia de navegación 
                y proporcionar servicios personalizados.
              </p>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
                <h3 className="font-semibold text-yellow-900 mb-3">Tipos de cookies que utilizamos:</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-yellow-700"><strong>Esenciales:</strong> Necesarias para el funcionamiento del sitio</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-yellow-700"><strong>Analíticas:</strong> Para entender cómo usan nuestro sitio</span>
                  </li>
                  <li className="flex items-start">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <span className="text-yellow-700"><strong>Funcionales:</strong> Para recordar sus preferencias</span>
                  </li>
                </ul>
                <p className="text-yellow-700 mt-4 text-sm">
                  Puede desactivar las cookies en la configuración de su navegador en cualquier momento.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Derechos del Usuario</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Usted tiene derecho a acceder, rectificar, cancelar u oponerse al tratamiento 
                de sus datos personales en cualquier momento.
              </p>
              <div className="bg-blue-50 rounded-lg p-6">
                <h3 className="font-semibold text-blue-900 mb-3">Para ejercer sus derechos:</h3>
                <p className="text-blue-700 mb-4">Contáctenos a través de:</p>
                <div className="space-y-2">
                  <p className="text-blue-700"><strong>Email:</strong> ventas@atomcorporations.com</p>
                  <p className="text-blue-700"><strong>Teléfono:</strong> +51 953 759 419</p>
                  <p className="text-blue-700"><strong>Dirección:</strong> Av. Industrial 1234, Lima, Perú</p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Cambios en la Política</h2>
              <p className="text-gray-600 leading-relaxed">
                Nos reservamos el derecho de actualizar esta política de privacidad periódicamente. 
                Cualquier cambio significativo será notificado a través de nuestro sitio web 
                o por correo electrónico.
              </p>
            </section>

            <div className="bg-gradient-to-r from-primary-600 to-accent-500 rounded-xl p-8 text-center text-white">
              <h3 className="text-2xl font-bold mb-4">¿Tienes preguntas sobre tu privacidad?</h3>
              <p className="text-blue-100 mb-6">
                Estamos aquí para ayudarte. Contáctanos y resolveremos todas tus dudas.
              </p>
              <a
                href="mailto:ventas@atomcorporations.com"
                className="inline-flex items-center bg-white text-primary-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              >
                Contactar a Privacidad
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;